import type React from 'react';

/**
 * Returns true if the click event has modifier keys held (Cmd, Ctrl, Shift)
 * or is a middle-click. In these cases, the browser should handle the
 * navigation natively (e.g., open in new tab) rather than SPA navigation.
 */
export function isModifiedClick(e: React.MouseEvent): boolean {
	return e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1;
}
